<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header @custom-event="getToken"></Header>
		<div class="page_content">
			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/tw/">首頁</a><span class="space">/</span><a href="/tw/user/index">我的帳戶</a><span class="space">/</span>自助下單
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			
			<!--页面内容-开始-->
			<div class="booking_success_box">
				<div v-if="orderCheck">
					<h1>訂單提交成功</h1>
					<h5>您的訂單提交成功！我們會在兩個工作天內給你發確認及付款通知，請注意查收郵件通知！<br />如需要幫忙請隨時聯絡我們的客服，謝謝！</h5>
					<div class="success_img"></div>
					<div class="btns">
						<div class="btn blue"><a :href="'/tw/user/order_detail?OrderNo='+orderNo">查看訂單詳情</a></div>
						<div class="btn hollow"><a href="/tw/user/orders">查看全部訂單</a></div>
					</div>
				</div>
				<div v-else style=" padding: 200px 0;">
					<h1>{{errMessage}}</h1>
				</div>
			</div>
			<!--页面内容-结束-->
		</div>
		<Footer></Footer>
	</div>
</template>


<script>
	import {
		checkToken,
		getOrderDetail,
		sendMail,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	export default {
		name: 'TW_UserBookingSuccess',
		mixins: [mixin],
		components: {
			Header,
			Footer,
		},
		data() {
			return {
				orderNo: null,	//订单编号
				fullscreenLoading: true, //loading状态
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				errMessage: '',
				orderDetail: [],	//订单详情
				orderCheck: false,	//订单验证
			}
		},
		created() {			
			// 获取orderNo
			if (this.$route.query.OrderNo != null && this.$route.query.OrderNo !='' && this.$route.query.OrderNo != undefined) {
				this.orderNo = this.$route.query.OrderNo
			}
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true					
					this.getData()
				}
				else
				{
					this.$router.push({
						path: '/tw/user/login'
					})
				}
			},
			//获取订单详情
			async getData() {
				const { data: res } = await getOrderDetail(this.language, this.token, this.terminal, this.orderNo)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.orderDetail = res.data
					this.orderCheck = true
					
					//发送邮件
					this.sendMail(this.orderNo)
				} else {
					this.errMessage = res.errmsg
				}
			},
			//发送邮件
			async sendMail(orderNo)
			{
				//组装请求数据
				let params={
					Token: this.token,
					Terminal: this.terminal,
					Language: this.language,
					OrderNumber: orderNo,
				}
				
				const { data: res } = await sendMail(params)
				if (res.errcode === 0) {
					console.log('郵件發送成功')
				} else {
					console.log(res.errmsg)
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;

	}
</style>